<template>
  <div class="height-250px">
    <div class="is-flex is-justify-content-center is-align-items-center full_height">
      <div>
        <div class="mb-2 has-text-left">Pick a date and time</div>
        <div><DateTime @input="pickDate" :date="freezedUntil" :show_time="false" /></div>
      </div>
    </div>
    <div class="modal_footer">
      <a @click="freeze(freezedUntil)" class="button is-info">Submit</a>
      <a @click="freeze('null')" class="button is-danger mx-3">Unfreeze</a>
    </div>
  </div>
</template>

<script>
import DateTime from '@/components/DateTime.vue'
import { mapMutations } from 'vuex'

export default {
  name: 'freeze-applicant-component',
  components: {
    DateTime
  },
  props: {
    payload: {
      type: Object
    },
    id: {
      type: [String, Number]
    },
    freezedDate: {
      type: String
    }
  },
  data () {
    return {
      freezedUntil: null
    }
  },
  created () {
    this.freezedUntil = this.freezedDate
  },
  methods: {
    pickDate (date) {
      this.freezedUntil = date
    },
    freeze (data) {
      this.$network_utils.updateApplicant({ applicant_id: this.id, freezed_until: data }).then(() => {
        this.$utils.emit('show_toast', { text: 'תאריך הקפאה עודכן' })
        this.removeModalById(this.payload.modal_id)
      })
    },
    ...mapMutations('modals', ['removeModalById'])
  }
}
</script>
